import React, { useEffect } from 'react'

function RefundPolicy(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div className="main-wrapper inner--page">
        <section
          className="hero-banner inner-banner center-bg"
          style={{ backgroundImage: `url('images/faq-banner.png')` }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="partner-banner-content">
                  <h1>
                    Refund Policy{' '}
                    <span style={{ color: '#42B749' }}>RoadJockey</span>
                  </h1>
                  <text>Last updated on: September 09th, 2021.</text>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="faq-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 offset-lg-1 text-left">
                <div className="faq-content">
                  <p>
                    We reserve the right to change this Refund Policy at any
                    time.
                  </p>
                  <h2 className="pt-5"> I. Refund Policy</h2>
                  <p>
                    At{' '}
                    <a href="roadjockey.com" target="_blank">
                      roadjockey.com
                    </a>
                    , our general policy is that
                    <b>
                      &nbsp; YOUR PAYMENT IS FINAL AND YOU WILL NOT BE ABLE TO
                      CANCEL THE BOOKING AND/OR RECEIVE A REFUND OF YOUR PAYMENT
                      UNLESS ITS DEEMED NEGLIGENCE ON OUR PART.{' '}
                    </b>
                    <br />
                    You may contact us for any issue, all refund-related issues
                    are assessed by our customer support team case by case and
                    actioned accordingly if it is deemed negligence on our part,
                    you could possibly be refunded.
                  </p>
                  <br />
                  <p>
                    We are happy to support you. If there is any issue, please
                    contact our customer support team for any inquiry or problem
                    at{' '}
                    <a href="mailto: info@roadjockey.com">
                      info@roadjockey.com
                    </a>{' '}
                    to start the refund process. If for any reason, our customer
                    support staff confirms a refund; <br />
                    Then, a refund will be made accordingly.
                  </p>

                  <h2 className="pt-5"> II. Methods of Payment and Refund</h2>
                  <p>
                    We will refund your amount to the original payment method
                    once it has been processed.
                  </p>

                  <h2 className="pt-5"> III. Refund Cycle</h2>
                  <p>
                    The complete refund process normally takes about 5-15
                    working days from the date of confirmation of the refund.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default RefundPolicy
